import { createFileRoute } from "@tanstack/react-router";
import AIStudyEngineeringGuide from "@/pages/resources/AIStudyEngineeringGuide";

export const Route = createFileRoute("/learn/ai-study-engineering")({
  head: () => ({
    meta: [
        {
            "title": "AI Study Methods for Engineering & Science Students | System Atlas"
        },
        {
            "name": "description",
            "content": "How to study engineering, physics, math, and science with AI. Structured revision sheets, formula-based quizzes, and spaced repetition for STEM students."
        },
        {
            "property": "og:title",
            "content": "AI Study Methods for Engineering & Science Students | System Atlas"
        },
        {
            "property": "og:description",
            "content": "How to study engineering, physics, math, and science with AI. Structured revision sheets, formula-based quizzes, and spaced repetition for STEM students."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/ai-study-engineering"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "AI Study Methods for Engineering & Science Students | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "How to study engineering, physics, math, and science with AI. Structured revision sheets, formula-based quizzes, and spaced repetition for STEM students."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/ai-study-engineering"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/ai-study-engineering"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/ai-study-engineering"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/ai-study-engineering"
        }
    ],
  }),
  component: AIStudyEngineeringGuide,
});
